import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { NewCompanyAdmin } from '../components/new-company-admin/new-company-admin';

const NewCompanyAdminRoute = () => {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId') ?? '';

  return <NewCompanyAdmin requestId={requestId} />;
};

export { NewCompanyAdminRoute };
